import { render } from "./Applicants.vue?vue&type=template&id=1bfdc72f&scoped=true"
import script from "./Applicants.vue?vue&type=script&lang=ts"
export * from "./Applicants.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Applicants.vue?vue&type=style&index=1&id=1bfdc72f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bfdc72f"

export default script